import { useLang } from "@/i18n";
import { experienceImages, photos } from "@/data/site";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBanner } from "@/components/site/CtaBanner";
import { SEO } from "@/components/site/SEO";

export default function Esperienze() {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.pages.esperienze.seo} description={t.pages.esperienze.desc} path="/esperienze" />
      <PageHero image={photos.spiaggiaTramonto} eyebrow={t.pages.esperienze.eyebrow} title={t.pages.esperienze.title} testid="esperienze-hero" />

      <section className="py-16 sm:py-24" data-testid="experiences-grid">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="mb-12 max-w-2xl text-base leading-relaxed text-ink-muted sm:text-lg">{t.experiences.text}</p>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {t.experiences.items.map((exp, i) => (
              <Reveal key={exp.id} delay={i * 0.05}>
                <article data-testid={`experience-detail-${exp.id}`} className="group overflow-hidden rounded-2xl border border-border bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                  <div className="h-56 overflow-hidden">
                    <img src={experienceImages[exp.id]} alt={exp.t} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <h2 className="font-serif text-xl font-semibold text-ink">{exp.t}</h2>
                    <p className="mt-2 text-sm leading-relaxed text-ink-muted">{exp.d}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
